"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionMarker = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _excluded = ["$hover", "$getDimensions", "$dimensionKey", "$geoService", "$onMouseAllow", "$prerender", "lat", "lng"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DirectionMarker = function DirectionMarker(_ref) {
  var $hover = _ref.$hover,
    $getDimensions = _ref.$getDimensions,
    $dimensionKey = _ref.$dimensionKey,
    $geoService = _ref.$geoService,
    $onMouseAllow = _ref.$onMouseAllow,
    $prerender = _ref.$prerender,
    lat = _ref.lat,
    lng = _ref.lng,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 16.2632L10 3L16 16.2632L15.2 17L10 15L4.8 17L4 16.2632Z",
    fill: "#0095E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.1795 14.5333L10 14.4643L9.82051 14.5333L4.91033 16.4219L4.60444 16.1401L10 4.2131L15.3956 16.1401L15.0897 16.4219L10.1795 14.5333Z",
    stroke: "white"
  })));
};
exports.DirectionMarker = DirectionMarker;